import React from 'react';

const MOCK_FEED = [
  {
    kind: 'tournament', who: 'Nina', verb: 'participe à', tone: 1, time: 'Il y a 2h',
    tournament: { name: 'Sunset Cup', format: '2×2', date: '24 Mai', photo: 'photo-sunset' },
    likes: 12, comments: 3,
  },
  {
    kind: 'quote', who: 'Mathieu', verb: 'a commenté', target: 'Pampelonne Beach', tone: 2, time: 'Il y a 4h',
    text: 'Super tournoi, super orga !!', context: 'Pampelonne Beach · Ramatuelle',
    likes: 8, comments: 1,
  },
  {
    kind: 'looking', who: 'Nino', verb: 'cherche un partenaire', tone: 3, time: 'Il y a 6h',
    format: '2×2', when: 'Ce week-end',
    text: 'Dispo samedi matin sur Lyon, niveau régional',
    likes: 4, comments: 0,
  },
  {
    kind: 'result', who: 'Sarah', verb: 'a joué', tone: 4, time: 'Hier',
    tournamentName: 'Open de Nantes', us: 'Les Requin·es', them: 'Beach Tigers',
    scores: [[21, 18], [19, 21], [15, 10]], podium: 1,
    likes: 22, comments: 7,
  },
  {
    kind: 'tournament', who: 'Léa', verb: 'participe à', tone: 5, time: 'Il y a 1j',
    tournament: { name: 'Open de Lyon', format: '4×4', date: '1 Juin', photo: 'photo-court' },
    likes: 5, comments: 0,
  },
];

function avatarColor(tone) {
  return `avatar-${((tone - 1) % 6) + 1}`;
}

function initials(name) {
  if (!name) return '?';
  return name.split(' ').map(n => n[0]).slice(0, 2).join('').toUpperCase();
}

function MsgIcon({ size = 14 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
    </svg>
  );
}

function ShareIcon({ size = 14 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/>
      <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/>
      <line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/>
    </svg>
  );
}

function MoreIcon({ size = 16 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="5" r="1" fill="currentColor"/>
      <circle cx="12" cy="12" r="1" fill="currentColor"/>
      <circle cx="12" cy="19" r="1" fill="currentColor"/>
    </svg>
  );
}

function PinIcon({ size = 11 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 22s7-7.5 7-13a7 7 0 1 0-14 0c0 5.5 7 13 7 13z"/>
      <circle cx="12" cy="9" r="2.5"/>
    </svg>
  );
}

function NewsTournament({ t }) {
  return (
    <div className="tourney-hero on-hero" style={{
      height: 130, padding: 12,
      display: 'flex', flexDirection: 'column', justifyContent: 'space-between',
      position: 'relative', borderRadius: 'var(--r-md)', overflow: 'hidden',
    }}>
      <div className={`hero-photo ${t.photo}`} />
      <div className="hero-tint" />
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <span className="chip" style={{
          color: 'rgba(255,255,255,0.9)',
          background: 'rgba(255,255,255,0.18)',
          borderColor: 'rgba(255,255,255,0.3)',
        }}>{t.format}</span>
        <span className="mono" style={{ color: 'rgba(255,255,255,0.75)' }}>{t.date}</span>
      </div>
      <div className="display" style={{ fontSize: 22, lineHeight: 0.95 }}>{t.name}</div>
    </div>
  );
}

function NewsCard({ item }) {
  return (
    <div className="card" style={{ padding: 14, marginBottom: 0 }}>
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: 10, marginBottom: 10 }}>
        <div className={`avatar-md ${avatarColor(item.tone)}`} style={{ flexShrink: 0 }}>
          {initials(item.who)}
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontSize: 13, lineHeight: 1.35 }}>
            <strong>{item.who}</strong>
            <span style={{ color: 'var(--text-2)' }}> {item.verb}</span>
            {item.target && <strong> {item.target}</strong>}
          </div>
          <span className="mono" style={{ color: 'var(--text-3)', display: 'block', marginTop: 2 }}>
            {item.time}
          </span>
        </div>
        <button style={{ color: 'var(--text-3)', background: 'none', border: 'none', padding: 4 }}>
          <MoreIcon />
        </button>
      </div>

      {item.kind === 'tournament' && <NewsTournament t={item.tournament} />}

      {item.kind === 'quote' && (
        <div style={{
          padding: '12px 14px', borderRadius: 'var(--r-md)',
          background: 'var(--ink-3)', position: 'relative',
        }}>
          <span style={{
            position: 'absolute', top: 6, left: 10, fontSize: 32,
            color: 'var(--sun-2)', fontFamily: 'Anton', lineHeight: 1, opacity: 0.5,
          }}>"</span>
          <div style={{ fontSize: 14, color: 'var(--text)', lineHeight: 1.45, paddingLeft: 14 }}>
            {item.text}
          </div>
          {item.context && (
            <div style={{ display: 'flex', alignItems: 'center', marginTop: 10, paddingLeft: 14, gap: 6 }}>
              <PinIcon />
              <span style={{ fontSize: 12, color: 'var(--text-3)' }}>{item.context}</span>
            </div>
          )}
        </div>
      )}

      {item.kind === 'looking' && (
        <div style={{ padding: 12, borderRadius: 'var(--r-md)', background: 'var(--ink-3)' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8, alignItems: 'center' }}>
            <span className="chip chip-cyan">{item.format}</span>
            <span className="mono" style={{ color: 'var(--text-3)' }}>{item.when}</span>
          </div>
          <div style={{ fontSize: 13, color: 'var(--text)', lineHeight: 1.4, marginBottom: 10 }}>
            « {item.text} »
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            <button className="btn btn-primary btn-sm" style={{ flex: 1 }}>Je joue avec toi</button>
            <button className="btn btn-ghost btn-sm" style={{ padding: '8px 12px' }}><MsgIcon /></button>
          </div>
        </div>
      )}

      {item.kind === 'result' && (
        <div style={{ padding: 14, borderRadius: 'var(--r-md)', background: 'var(--ink-3)' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 10, alignItems: 'center' }}>
            <span style={{ fontSize: 13, fontWeight: 700, color: 'var(--text)' }}>{item.tournamentName}</span>
            <span className={`chip ${item.podium === 1 ? 'chip-sun' : 'chip-cyan'}`}>
              {item.podium === 1 ? '🏆 1er' : item.podium === 2 ? '🥈 2e' : '🥉 3e'}
            </span>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div>
              <div style={{ fontSize: 13, fontWeight: 700 }}>{item.us}</div>
              <div style={{ fontSize: 12, color: 'var(--text-3)', marginTop: 2 }}>vs. {item.them}</div>
            </div>
            <div style={{ display: 'flex', gap: 12 }}>
              {item.scores.map((s, i) => (
                <span key={i} className="score" style={{
                  fontSize: 22,
                  color: s[0] > s[1] ? 'var(--sun-2)' : 'var(--text-3)',
                }}>{s[0]}-{s[1]}</span>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Réactions */}
      <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 12, alignItems: 'center' }}>
        <div style={{ display: 'flex', gap: 16 }}>
          <button style={{
            display: 'flex', alignItems: 'center', gap: 4,
            color: 'var(--text-2)', fontSize: 13, fontWeight: 600,
            background: 'none', border: 'none', padding: 0,
          }}>
            🏐 <span>{item.likes}</span>
          </button>
          <button style={{
            display: 'flex', alignItems: 'center', gap: 4,
            color: 'var(--text-2)', fontSize: 13, fontWeight: 600,
            background: 'none', border: 'none', padding: 0,
          }}>
            <MsgIcon /> <span>{item.comments}</span>
          </button>
        </div>
        <button style={{ color: 'var(--text-3)', background: 'none', border: 'none', padding: 4 }}>
          <ShareIcon />
        </button>
      </div>
    </div>
  );
}

function Actu() {
  return (
    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden', minHeight: 0, background: 'var(--ink)' }}>
      <div style={{
        padding: '16px 20px 12px', flexShrink: 0, borderBottom: '1px solid var(--line)',
      }}>
        <div className="display" style={{ fontSize: 26, color: 'var(--text)' }}>Actu</div>
      </div>

      <div className="page-content">
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12, padding: '16px 16px 100px' }}>
          {MOCK_FEED.map((item, i) => (
            <NewsCard key={i} item={item} />
          ))}
        </div>
      </div>
    </div>
  );
}

export default Actu;
